// A VÁZLAT-JELZÉS: „Vázlat mentve · 12:03" + „Vázlat elvetése" — minden autosave-es beviteli helynek ugyanaz a
// sora (jegy-válasz, partner-portál válasz, üzenet). A mentés maga a `useDraft` hookban él.
import { TrashIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { formatDateTime, useTimeZone } from '@/lib/format-datetime';

export interface DraftStatusProps {
  savedAt: Date | null;
  /** A vázlat elvetése (a szöveget a hívó üríti) — hiányában nincs gomb. */
  onDiscard?: () => void;
  disabled?: boolean;
}

export function DraftStatus({
  savedAt,
  onDiscard,
  disabled = false,
}: DraftStatusProps): JSX.Element | null {
  const { t, i18n } = useTranslation();
  const timeZone = useTimeZone();
  if (savedAt === null) return null;
  return (
    <div className="flex items-center gap-2" data-testid="draft-status">
      <span className="text-subtle text-xs" aria-live="polite">
        {t('drafts.saved', {
          time: formatDateTime(savedAt.toISOString(), i18n.language, timeZone, {
            timeStyle: 'short',
          }),
        })}
      </span>
      {onDiscard && (
        <Button type="button" size="xs" variant="ghost" onClick={onDiscard} disabled={disabled}>
          <TrashIcon />
          {t('drafts.discard')}
        </Button>
      )}
    </div>
  );
}
